import { FC, useLayoutEffect } from 'react';
import { EFreeBetsActions } from 'newelements/_Betslip/managers/FreeBetManager/actions';
import { TFreeBetManagerSlicesProps } from 'newelements/_Betslip/managers/FreeBetManager/types';
import { getSingleEventsFreeBets } from 'newelements/_Betslip/managers/FreeBetManager/utils/fetchFreeBetAmounts/single';
import { useEventbus } from 'newhooks/generic/useEventbus';

// in this slice wrote freeBet data fetching for single bets and switching freeBet selector logic
export const FreeBetManagerSliceSingle: FC<TFreeBetManagerSlicesProps> = ({
  getOnMount = false
}) => {
  useLayoutEffect(() => {
    if (getOnMount) {
      getSingleEventsFreeBets();
    }
  }, []);

  useEventbus({
    [EFreeBetsActions.GET_FREE_BETS]: getSingleEventsFreeBets
  });

  return null;
};
